export default "__VITE_ASSET__Ck2h6Psh__"